import type { PaymentTier, PaymentLanguage } from '../types/i18n'

export const WHY_CHOOSE_US_DATA : {title:string, text:string}[] = [
	{
		title: 'Uhvatite 10x više trenutaka!',
		text: 'Ne propustite nijedan osmijeh, suzu radosnicu ili spontani ples. Svaki gost postaje vaš fotograf — kutovi i trenuci koje sami nikad ne biste uhvatili.'
	},
	{
		title: '500+ fotografija na jednom mjestu',
		text: 'Sve fotografije svih gostiju organizirane u zajedničkoj galeriji. Bez čekanja, bez traženja po grupama.'
	},
	{
		title: 'Preuzmite jednim klikom',
		text: 'Bez kompliciranja — preuzmite sve fotografije odjednom ili odaberite omiljene. Zauvijek vaše, bez vremenskog ograničenja.'
	},
	{
		title: '30 sekundi do galerije',
		text: 'Bez registracije, bez računa, bez dodatnih koraka. QR kod + PIN = gost je spreman za slikanje.'
	}
]

export const WHY_CHOOSE_US_DATA_EN : {title:string, text:string}[] = [
	{
		title: 'Capture Every Moment!',
		text: 'Don’t miss a single smile, joyful tear, or impromptu dance move. With Wedding Camera, every guest can be part of your story, creating a rich collection of authentic moments from your big day.'
	},
	{
		title: 'All in One Place',
		text: 'All photos are organized in a shared gallery, accessible to you and your guests, making it easy to relive the memories together.'
	},
	{
		title: 'Easy Downloads',
		text: 'Guests can effortlessly download their favorite photos to their devices, while you enjoy every image captured at your wedding.'
	},
	{
		title: 'Stress-Free Experience',
		text: 'The app is intuitive and user-friendly, allowing your guests to focus on celebrating instead of worrying about technology.'
	}
]

export const FAQ_DATA : {title:string, text:string}[] = [
	{
		title: 'Koliko košta Wedding Camera aplikacija?',
		text: 'Wedding Camera ima tri paketa: aktualne cijene su Osnovni (14,99 €), Premium (34,99 €) i Ekskluzivni (49,99 €). Sidrene cijene koje su vrijedile 10. rujna 2026. bile su redom 14,99 €, 34,99 € i 49,99 €. Svi paketi uključuju dizajn letka za print i pristup online galeriji.'
	},
	{
		title: 'Koja je najbolja aplikacija za fotografije s vjenčanja?',
		text: 'Wedding Camera je #1 aplikacija za prikupljanje fotografija s vjenčanja u Hrvatskoj. Više od 2.000 parova koristi našu aplikaciju jer je jednostavna (bez registracije), privatna (PIN zaštita) i sve fotografije ostaju zauvijek dostupne.'
	},
	{
		title: 'Kako podijeliti slike s vjenčanja s gostima?',
		text: 'S Wedding Camera aplikacijom, svi gosti skeniraju QR kod i unose PIN — to je sve! Slike se automatski dijele u zajedničku galeriju koju svi mogu pregledati i preuzeti.'
	},
	{
		title: 'Kako moji gosti mogu preuzeti i koristiti wedding camera aplikaciju?',
		text: 'Svi vaši gosti wedding camera aplikaciju mogu preuzeti pomoću QR koda koji će se nalaziti na letcima u sali ili na nekom drugom mjestu, ovisno o vašim specifičnim željama.'
	},
	{
		title: 'Moraju li gosti imati korisnički račun kako bi koristili aplikaciju?',
		text: 'Ne, vaši gosti ne moraju imati korisnički račun. Dovoljno je da na dan vjenčanja skinu aplikaciju na svoje uređaje putem QR koda i prijave se pomoću PIN-a koji omogućava pristup vjenčanju i zajedničkoj galeriji.'
	},
	{
		title: 'Kako se dodaju fotografije u zajedničku galeriju?',
		text: 'Gosti mogu slikati direktno iz aplikacije ili odabrati fotografije iz svoje galerije.'
	},
	{
		title: 'Tko može vidjeti i preuzeti fotografije?',
		text: 'Samo mladenci i gosti koji imaju pristup jedinstvenom PIN-u mogu vidjeti i preuzeti fotografije. Aplikacija je zaštićena, pa nitko izvan vašeg vjenčanja neće imati pristup fotografijama.'
	},
	{
		title: 'Jesu li moje fotografije sigurne i privatne u aplikaciji?',
		text: 'Da, sve vaše fotografije su sigurne i privatne. Aplikacija je zaštićena jedinstvenim PIN-om, što osigurava da samo pozvani gosti i mladenci mogu vidjeti ili preuzeti slike. Nitko drugi nema pristup vašim fotografijama.'
	}
	// {
	// 	title: 'Gdje mogu pronaći letke za salu?',
	// 	text: 'Ništa ne brinite, mi vam dostavljamo digitalni letak spreman za print. Ako želite, letke i stalke za stolove možete naknadno kupiti. Vi samo recite koliko stolova imate u sali, a ostalo prepustite nama.'
	// },
	// {
	// 	title: 'Zašto bih koristila vašu aplikaciju kad konkurencija nudi slične mogućnosti bez preuzimanja aplikacije?',
	// 	text: 'Naša aplikacija pruža brži i jednostavniji pristup, omogućujući vam trenutni ulazak bez potrebe za ponovnim prijavljivanjem ili otvaranjem preglednika.'
	// },
	// {
	// 	title: 'Kada će mi moje fotografije sa vjenčanja biti dostupne?',
	// 	text: 'Fotografije će vam biti dostupne u roku od 48 sati nakon vjenčanja.'
	// }
	// {
	// 	title: 'Da li je za korištenje aplikacije potreban internet?',
	// 	text: 'Da, za prijenos i pregled slika je potreban pristup internetu.'
	// },
	// {
	// 	title: 'Naše vjenčanje je na imanju bez interneta, kako će moji gosti koristiti aplikaciju?',
	// 	text: 'Ne brinite, gostima je omogućen prijenos i dodavanje slika 24h nakon vjenčanja.'
	// },
	// {
	// 	title: 'Kako se dodaju fotografije u zajedničku galeriju?',
	// 	text: 'Gosti mogu slikati direktno iz aplikacije ili odabrati fotografije iz svoje galerije.'
	// },
	// {
	// 	title: 'Tko može vidjeti i preuzeti fotografije?',
	// 	text: 'Samo mladenci i gosti koji imaju pristup jedinstvenom PIN-u mogu vidjeti i preuzeti fotografije. Aplikacija je zaštićena, pa nitko izvan vašeg vjenčanja neće imati pristup fotografijama.'
	// },
	// {
	// 	title: 'Jesu li moje fotografije sigurne i privatne u aplikaciji?',
	// 	text: 'Da, sve vaše fotografije su sigurne i privatne. Aplikacija je zaštićena jedinstvenim PIN-om, što osigurava da samo pozvani gosti i mladenci mogu vidjeti ili preuzeti slike. Nitko drugi nema pristup vašim fotografijama.'
	// }
]
export const FAQ_DATA_EN : {title:string, text:string}[] = [
	{
		title: 'How can my guests download and use the Wedding Camera app?',
		text: 'All your guests can download the Wedding Camera app by scanning the QR code provided on the flyers in the venue or any other location based on your preferences.'
	},
	{
		title: 'Where can I find flyers for the venue?',
		text: 'Don’t worry, we will provide a digital flyer ready for printing.'
	},
	{
		title: 'Why should I use your app when competitors offer similar options without the need to download an app?',
		text: 'Our app offers faster and easier access, allowing you to instantly enter without having to log in again or open a browser.'
	},
	{
		title: 'When will my wedding photos be available?',
		text: 'Your photos will be available within 48 hours after the wedding.'
	},
	{
		title: 'Do guests need a user account to use the app?',
		text: 'No, your guests don’t need a user account. They just need to download the app on their devices using the QR code on the wedding day and log in with the PIN that grants access to the wedding and the shared gallery.'
	},
	{
		title: 'Is an internet connection required to use the app?',
		text: 'Yes, internet access is required to upload and view photos.'
	},
	{
		title: 'Our wedding is at a venue without internet. How will my guests use the app?',
		text: 'Don’t worry, guests will be able to upload and add photos for up to 24 hours after the wedding.'
	},
	{
		title: 'How are photos added to the shared gallery?',
		text: 'Guests can take photos directly from the app or select pictures from their gallery.'
	},
	{
		title: 'Who can view and download photos?',
		text: 'Only the couple and guests who have access to the unique PIN can view and download photos. The app is protected, so no one outside of your wedding will have access to the photos.'
	},
	{
		title: 'Are my photos safe and private in the app?',
		text: 'Yes, all your photos are safe and private. The app is protected with a unique PIN, ensuring that only invited guests and the couple can view or download the images. No one else has access to your photos.'
	}
]

export const REVIEWS_DATA : {title:string, text:string}[] = [
	{
		title: 'Ivana P.',
		text: 'Aplikacija je bila savršena za naše vjenčanje! Antonija i Matko su bili uz nas kroz cijeli proces postavljanja aplikacije. Gosti su mogli bez problema slikati i odmah dijeliti fotografije. Nema više čekanja da fotografi pošalju slike – sve smo imali dostupno u vrlo kratkom roku. Također, super je što smo mogli preuzeti sve fotografije i sačuvati ih za uspomenu. Topla preporuka!'
	},
	{
		title: 'Marko S.',
		text: 'Jednostavno i efikasno rješenje za svaki event! Gosti su uživali koristeći aplikaciju, a fotografije su odmah bile dostupne. Najbolje od svega je što smo svi mogli podijeliti slike i s lakoćom ih preuzeti.'
	},
	{
		title: 'Ana K.',
		text: 'Wedding camera je promijenila način na koji gledamo na vjenčanja! Svi gosti su se uključili i snimili predivne trenutke. Album nam je bio dostupan 48 sati nakon vjenčanja, što nas je oduševilo. Odlična ideja za sve koji žele spontano zabilježiti svaku sekundu svog dana!'
	}
]
export const REVIEWS_DATA_EN : {title:string, text:string}[] = [
	{
		title: 'Ivana P.',
		text: 'The app was perfect for our wedding! Antonija and Matko were with us throughout the entire setup process. Guests were able to take photos and immediately share them without any issues. No more waiting for photographers to send pictures – we had everything available in a very short time. Also, it was great that we could download all the photos and keep them as memories. Highly recommended!'
	},
	{
		title: 'Marko S.',
		text: 'A simple and efficient solution for any event! Guests enjoyed using the app, and the photos were instantly available. Best of all, we could all share images and easily download them.'
	},
	{
		title: 'Ana K.',
		text: 'Wedding Camera changed the way we view weddings! All guests participated and captured beautiful moments. The album was available to us 48 hours after the wedding, which amazed us. A great idea for anyone who wants to spontaneously capture every second of their day!'
	}
]

type PaymentLinks = {
	dev: Record<PaymentLanguage, Record<PaymentTier, string>>
	prod: Record<PaymentLanguage, Record<PaymentTier, string>>
}

export const paymentLinks: PaymentLinks = {
	dev: {
		en: {
			basic: 'https://buy.stripe.com/test_aFa8wQ7090QU3su7ub7IY04',
			premium: 'https://buy.stripe.com/test_00w9AU709fLO4wy4hZ7IY03',
			exclusive: 'https://buy.stripe.com/test_5kQ8wQfwFeHK3su7ub7IY05'
		},
		de: {
			basic: 'https://buy.stripe.com/test_6oU00k0BL436fbcaGn7IY08?locale=de',
			premium: 'https://buy.stripe.com/test_4gMdRacktbvy6EG8yf7IY06?locale=de',
			exclusive: 'https://buy.stripe.com/test_dRm6oI98harue7815N7IY07?locale=de'
		},
		hr: {
			basic: 'https://buy.stripe.com/test_00geWLgY1aGE4GA9AA?locale=hr',
			premium: 'https://buy.stripe.com/test_14k15VgY1eWU1uo8wx?locale=hr',
			exclusive: 'https://buy.stripe.com/test_aEU15VcHLbKI5KEaEG?locale=hr'

		}
	},
	prod: {
		en: {
			basic: 'https://buy.stripe.com/14A3cwbgpgPS9QS29R7IY0a',
			premium: 'https://buy.stripe.com/4gM7sM3NX8jmfbc7ub7IY0c',
			exclusive: 'https://buy.stripe.com/3cI3cwcktfLOgfg6q77IY09'
		},
		de: {
			basic: 'https://buy.stripe.com/4gMdRacktbvy6EG8yf7IY06?locale=de',
			premium: 'https://buy.stripe.com/6oU00k0BL436fbcaGn7IY08?locale=de',
			exclusive: 'https://buy.stripe.com/dRm6oI98harue7815N7IY07?locale=de'
		},
		hr: {
			basic: 'https://buy.stripe.com/00w9AU709fLO4wy4hZ7IY03?locale=hr',
			premium: 'https://buy.stripe.com/aFa8wQ7090QU3su7ub7IY04?locale=hr',
			exclusive: 'https://buy.stripe.com/5kQ8wQfwFeHK3su7ub7IY05?locale=hr'
		}
	}
}
